<template>
	<div class="serivce">
		<h1>拍界VIP会员福利政策</h1>
		<p>
			1、免除拍界平台软件使用费（按照标的成交额的0.5%收取）<br>
			2、免费推送拍界全年标的<br>
			3、报名截止时间延长至标的开拍前1小时<br>
			4、拍界特殊标的议价权（特殊标的：流拍标的、可议价标的、不通过拍卖急于处理的标的）<br>
			5、拍界VIP会员费：原价10888元/年，<span style="color:#ff0000">2020年11月23日-2021年2月11日，优惠价格<strong>3888元/年</strong>。</span><br>
			6、缴费方式：线下支付<br>
公司名称：吉林省崇晟科贸有限公司<br>
开户行：中国建设银行股份有限公司长春华正支行<br>
账号：22050131006600000135
		</p>
		<!-- <span @click="goBack">返回></span> -->
	</div>
</template>

<script>
export default {
	metaInfo: {
		title: "拍界——唤醒您的沉睡资产",
		meta: [{
			name: "keywords",
			content: "拍界，拍界官网，捡漏，拍卖，手机拍卖，二手设备拍卖，废旧物资拍卖，整厂拍卖，房屋拍卖，车辆拍卖，土地拍卖，小商品拍卖"
		}, {
			name: "description",
			content: "拍界是一个专注拍卖的网络平台，拍卖无边界，拍卖更便捷。拍界，拍界官网，捡漏，拍卖，手机拍卖，二手设备拍卖，废旧物资拍卖，整厂拍卖，房屋拍卖，车辆拍卖，土地拍卖，小商品拍卖"
		}]
	},
	methods:{
		goBack: function (){
			this.$router.go(-1)
		}
	}
}
</script>